import React from "react";
import { Box } from "aws-northstar";

import version from "../../version.json";

const Footer: React.FC = () => {
    return (
        <Box
            padding="s"
            style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                height: "50px",
                backgroundColor: "#232f3e", // AWS NorthStar header dark blue
                borderTop: "1px solid #465464",
                zIndex: 2000,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingLeft: "16px",
                paddingRight: "16px",
            }}
            textAlign="center"
        >
            <div style={{ color: "#ffffff", fontSize: "12px" }}>
                © {new Date().getFullYear()} Data Breakglass Broker. All rights reserved.
            </div>
            <div style={{ color: "#ffffff", fontSize: "12px", fontFamily: "Roboto Mono, monospace" }}>
                builddate: {version.buildDate} version: {version.buildNumber} hash: {version.gitHash}
            </div>
        </Box>
    );
};

export default Footer;
